import DocumentFolder from "./DocumentFolder.Component";
import { ReactComponent as FolderIcon } from "../../../../assets/Icons/Setting/Profile/FolderIcon.svg";
import { useRef } from "react";

const FolderViewer = ({ data, handelNewFolder, setFileFolderHistory }) => {
  const createAdminProfileDocumentFileRef = useRef(null);
  const handelFolderCreate = () => {
    const folderTxtInput = document.createElement("input");
    folderTxtInput.name = "folderInputName";
    folderTxtInput.classList.add("folderTextInput");
    folderTxtInput.placeholder = "Enter folder name";

    const folderCreateTxt = document.createElement("span");
    folderCreateTxt.innerText = "Create folders";
    folderCreateTxt.className = "t-14 poppins-medium";

    // console.log("click folder create");
    createAdminProfileDocumentFileRef.current.children[1].remove();
    createAdminProfileDocumentFileRef.current.append(folderTxtInput);

    folderTxtInput.addEventListener("keypress", (e) => {
      // console.log(e.key);
      if (e.key === "Enter") {
        handelNewFolder(folderTxtInput.value.toString());
        removeInputAndCreateFolder(folderCreateTxt);
      }
    });
  };

  const removeInputAndCreateFolder = (folderCreateTxt) => {
    for (let child of createAdminProfileDocumentFileRef.current.children) {
      if (child.tagName.toLowerCase() === "input") {
        // createAdminProfileDocumentFileRef.current.remove(child);
        // folderCreateTxt.innerText = child.value;
        child.remove();
        break; // remove only the first matching child
      }
    }
    createAdminProfileDocumentFileRef.current.append(folderCreateTxt);
  };

  return (
    <div className="adminProfileDocumentContainer">
      <button
        ref={createAdminProfileDocumentFileRef}
        type="button"
        className="createAdminProfileDocumentFile"
        onDoubleClick={handelFolderCreate}
      >
        <FolderIcon fill="#ff9d00" />
        <span className="t-14 poppins-medium">Create folders</span>
      </button>

      {data.map((folderData) => {
        return (
          <DocumentFolder
            folderName={folderData.name}
            onDoubleClick={(e) => setFileFolderHistory(folderData.name)}
          />
        );
      })}
    </div>
  );
};

export default FolderViewer;
